let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aROx1")).then(() => parcelRequire('kmLyu'));